export * from "./ToteBetsApiBetResponse";
//# sourceMappingURL=index.js.map